import { Button } from '@/shared/components/ui/button';
import { Link } from '@/shared/components/ui/link';

interface NavigatableItemProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  label: string;
  href: string;
  isSelected: boolean;
}

export const NavigationItem = ({
  icon: Icon,
  label,
  href,
  isSelected,
}: NavigatableItemProps) => {
  return (
    <div className="flex w-full flex-col items-center py-2 text-center text-[8px] text-white">
      <Button
        className="[&_svg]:size-6"
        variant={isSelected ? 'secondary' : 'ghost'}
        btnType="icon"
        shape="square"
        asChild
      >
        <Link to={href}>
          <Icon />
        </Link>
      </Button>
      <div className="w-full overflow-hidden text-ellipsis">{label}</div>
    </div>
  );
};
